import { useEffect, useState, useMemo, memo } from "react";
import { findAllImage } from "../../api/apiService";

const Cards = memo(({ data }) => {
    const [imageUrls, setImageUrls] = useState([]);

    const imageIds = useMemo(() => {
        const cards = data?.cards || [];
        return cards.map(card => card.image).filter(Boolean);
    }, [data]);

    useEffect(() => {
        if (!imageIds.length) return;

        const loadImages = async () => {
            try {
                const idsParam = imageIds.join(",");
                const res = await findAllImage(idsParam);
                const urls = res?.data?.[0]?.data || [];
                setImageUrls(urls);
            } catch (err) {
                console.error("Error loading images:", err);
            }
        };

        loadImages();
    }, [imageIds]);

    return (
        <div className="flex flex-wrap gap-4 justify-center">
            {data?.cards?.map((card, i) => (
                <div
                    key={i}
                    className={`p-4 md:p-6 rounded-2xl border-2 border-white flex flex-col justify-start text-left
            ${data?.cards.length === 3
                            ? "w-full md:w-[280px]"
                            : "w-full md:w-[300px] lg:w-[360px]"
                        } min-h-[200px] md:min-h-[220px]`}
                    style={{
                        background:
                            "linear-gradient(to bottom right, #F0F0E5, #FFFFFF, #F0F0E5)",
                    }}
                >
                    {imageUrls[i] ? (
                        <img
                            src={imageUrls[i]}
                            alt="icon"
                            className="w-10 h-10 md:w-14 md:h-14 mb-2 md:mb-3"
                        />
                    ) : (
                        <div className="w-10 h-10 md:w-14 md:h-14 mb-2 md:mb-3 bg-gray-200 rounded"></div>
                    )}
                    <h3 className="font-bold text-base md:text-lg text-[#56453F] mb-2">
                        {card.heading}
                    </h3>
                    <p className="text-sm md:text-base text-[#56453F]">
                        {card.content}
                    </p>
                </div>
            ))}
        </div>
    );
})

export default Cards;
